import { Button, Modal, TextBlock, Title } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from './InsufficientBalanceModal.module.scss';

export type TInsufficientBalanceModalProps = {
  ctaLabel?: string;
  isCtaDisabled?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onGoToBalance: () => void;
};

export function InsufficientBalanceModal({
  ctaLabel,
  isCtaDisabled = false,
  isOpen,
  onClose,
  onGoToBalance,
}: TInsufficientBalanceModalProps) {
  const { t } = useTranslation('modals');
  const description = t('insufficientBalance.description');
  const title = t('insufficientBalance.title');
  const resolvedCtaLabel = ctaLabel ?? t('insufficientBalance.cta');

  return (
    <Modal
      classNameModal={styles.modal}
      description={description}
      isOpen={isOpen}
      onBeforeClose={onClose}
      size="l"
      title={title}
    >
      <div className={styles.content} data-testid="insufficient-balance-modal">
        <div aria-hidden="true" className={styles.foregroundImage}></div>

        <header className={styles.header}>
          <Title as="h2" className={styles.title} color="contrast">
            {title}
          </Title>

          <TextBlock className={styles.description} color="contrast">
            {description}
          </TextBlock>
        </header>

        <Button
          className={styles.actionButton}
          color="accent"
          data-testid="insufficient-balance-modal-cta"
          disabled={isCtaDisabled}
          onClick={onGoToBalance}
          size="s"
          type="button"
          variant="filled"
        >
          {resolvedCtaLabel}
        </Button>
      </div>
    </Modal>
  );
}
